define([
    "angular",
    "angular-translate"
], function (angular) {
    "use strict";

    return angular.module("xlsModule", [
        "pascalprecht.translate"
    ]);
});